export default __webpack_public_path__ + "static/media/gmx_logo.4c149437.svg";